<div class="settings__content">
  <div class="settings__header-title">
    <span class="lx-section-title">Settings</span>
  </div>
  <div class="settings__tab-container">
    <a routerLink="./hierarchy" routerLinkActive="selected" class="settings__toggle">Hierarchy</a>
    <a routerLink="./requests" routerLinkActive="selected" class="settings__toggle">Modification Request</a>
    <a *renderingPermissionDirective="['SettingTypeAdmin']" routerLink="./types" routerLinkActive="selected" class="settings__toggle">Types</a>
  </div>
  <router-outlet></router-outlet>
</div>
